export const BADGE_INFO = {
  VERIFIED_AUTHOR: {
    title: 'Verified Author',
    description:
      'This creator has been verified by Twygs as an authentic, high-quality contributor.'
  },
  FOUNDING_CREATOR: {
    title: 'Founding Creator',
    description: 'Part of the founding community who helped build Twygs from day one.'
  }
};
